export const styles: Record<string, any> = {
    container: {
        maxW: { base: 'calc(100%)', md: '500px' },
        p: '20px',
        mx: { base: 'auto', md: 'auto' },
        flex: 1,
        backgroundColor: '#fff',
        justifyContent: 'center',
        flexDir: 'column',
        height: 'calc(100dvh - 59px)',
        maxHeight: '-webkit-fill-available',
        label: {
            mr: '0',
            mb: '12px',
            fontSize: '18px',
            fontWeight: 'bold'
        }
    },
    attract: {
        opacity: {
            base: 1,
            lg: 1
        },
        backgroundColor: '#181425',
        width: '100%',
        minHeight: '100dvh',
        '.chakra-heading': {
            color: 'yellow.400'
        },
        '.chakra-text': {
            color: 'yellow.400'
        }
    },
    grid: {
        pos: 'absolute',
        height: '100%',
        width: '100%',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0
    },
    qaDirectorContainer: {
        gap: '20px',
        maxW: { base: 'calc(100%)' },
        p: '20px',
        mx: { base: 'auto', md: 'auto' },
        flex: 1,
        backgroundColor: '#fff',
        justifyContent: 'center',
        flexDir: 'row',
        height: 'calc(100dvh - 59px)',
        maxHeight: '-webkit-fill-available',
        'div.director': {
            maxW: { base: 'calc(100%)', md: '500px' }
        },
        'iframe.vdoNinja': {
            width: 'calc(100% - 500px)',
            maxW: 'calc(1230px)'
        },
        label: {
            mr: '0',
            mb: '12px',
            fontSize: '18px',
            fontWeight: 'bold'
        }
    },
    joinRoom: {
        input: {
            // textTransform: 'uppercase'
        }
    },
    inputWrapper: {
        input: {
            fontSize: '18px',
            fontWeight: '700',
            border: '2px solid',
            borderRadius: 0,
            borderColor: 'yellow.400',
            background: 'yellow.200',
            pr: '40px'
        },
        '.bend': {
            position: 'absolute',
            bg: 'white',
            bottom: '0px',
            right: '0px',
            borderStyle: 'solid',
            h: 'auto',
            aspectRatio: '1/1',
            w: '5%',
            boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
            transition: 'all 0.5s',
            zIndex: 2,
            overflow: 'hidden',
            '&:after': {
                pointerEvents: 'none',
                color: 'yellow.100',
                background:
                    'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
                content: '""',
                display: 'block',
                pos: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            button: {
                pos: 'absolute',
                right: '20px',
                bottom: '20px'
            }
        },
        '&:hover': {
            transitionDelay: '.1s',
            borderColor: 'yellow.400'
        },
        '&:hover .bend': {
            w: '8%'
        }
    }
}